import { __assign } from "tslib";
import { buildConditionalStateId } from './buildConditionalStateId';
/**
 *
 * @param timeline
 * @param animationName
 */
export var getAnimationFromTimeline = function (timeline, animationName) {
    return timeline &&
        timeline.animations &&
        timeline.animations.find(function (a) { return a.name === animationName; });
};
/**
 * Collect symbols from ad
 */
export var collectSymbolsFromAd = function (ad) {
    return Object.keys(ad.symbols).map(function (symKey) { return ad.symbols[symKey]; });
};
/**
 * Collect only visible symbols from ad corresponding to the layout
 */
export var getVisibleSymbolsInLayout = function (ad, layoutId) {
    var allSymbols = collectSymbolsFromAd(ad);
    return allSymbols.filter(function (sym) {
        var conditionalStateId = buildConditionalStateId(sym.id, layoutId);
        var conditionalState = ad.conditionalStates[conditionalStateId];
        return conditionalState && conditionalState.visible;
    });
};
/**
 * Attaches any UTM overrides to the Window, so that
 * they are available when building click-thru URLs.
 */
export var setUTMOverrides = function (ad, layoutId) {
    var globalOverrides = ad.utms || {};
    var layoutOverrides = ad.layouts[layoutId].utms || {};
    window.ADAPT_UTM_OVERRIDES = __assign(__assign({}, globalOverrides), layoutOverrides);
};
